module.exports = __webpack_public_path__ + "img/CH.f67c3d93.svg";